export default __webpack_public_path__ + "static/mandeville-lakefront-54b41c14b9a602b9062c2ed16b556c2b.jpeg";